import type {ReasonCategory} from './types';

export const INTEGRATION_REASON =
    "Nutshell doesn't integrate with another important system or app our organization uses";

export const cancelReasonCategories: ReasonCategory[] = [
    {
        title: 'Product Issues',
        options: [
            {value: 'I experienced too many bugs or technical issues'},
            {value: 'Nutshell is missing features I need / not launching new features'},
            {value: 'Nutshell was difficult to use or not user-friendly'},
            {value: 'I need more customization or flexibility in my CRM'},
            {
                value: INTEGRATION_REASON,
                followUp: {
                    id: 'whatSystemAreYouTryingToConnectWith',
                    label: 'What system or app are you trying to connect with?',
                    placeholder: 'Enter system or app name',
                },
            },
        ],
    },
    {
        title: 'Pricing and Value',
        options: [
            {value: 'We found a better CRM for our budget'},
            {value: "Nutshell didn't provide enough value for the cost"},
            {value: "I'm reducing costs or cutting tools"},
            {value: 'Nutshell is too expensive for our budget'},
        ],
    },
    {
        title: 'Usage-Related',
        options: [
            {value: 'My team had trouble adopting Nutshell'},
            {value: "I didn't use Nutshell enough"},
            {value: 'I only needed Nutshell for a limited period of time'},
        ],
    },
    {
        title: 'Business or Personal Changes',
        options: [
            {value: 'I had trouble getting started with Nutshell'},
            {value: 'I no longer need a CRM or am not using one anymore'},
            {value: 'My business is closing or changing direction'},
            {value: "I'm switching jobs or roles and no longer need a CRM"},
        ],
    },
    {
        title: 'Customer Service Issues',
        options: [
            {value: "Customer support didn't resolve my issues"},
            {value: 'Response times from support were too long'},
            {value: "My onboarding experience didn't meet my needs"},
        ],
    },
];

export const crmOptions: string[] = [
    'Act!',
    'Active Campaign',
    'Close.io',
    'Copper',
    'Custom CRM',
    'Freshsales',
    'GoHighLevel',
    'Hubspot',
    'Industry Specific CRM',
    'Insightly',
    'Keap',
    'Less Annoying CRM',
    'Microsoft Dynamics',
    'Monday',
    'Netsuite',
    'Nimble',
    'NoCRM',
    'Onepage',
    'Pipedrive',
    'Pipeline',
    'SageCRM',
    'Salesforce',
    'Smartsheet',
    'Spreadsheets',
    'SugarCRM',
    'Zoho',
    'CRM not listed above',
];

export const recommendScoreOptions = [
    '0',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    '10',
] as const;
